import React from 'react';
import { RadioButtonProps } from '../../atoms';

export const injectRadioButtonProps = (
  children: React.ReactElement<RadioButtonProps> | React.ReactElement<RadioButtonProps>[],
  value?: string | number,
  onValueChange?: (value: string | number) => void,
) => {
  return React.Children.map(children,(child) => {
    const originalOnChange = child.props.onChange;
    return React.cloneElement(child, {
      checked: value !== undefined && child.props.value === value,
      onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked;
        if (isChecked) {
          onValueChange?.(child.props.value || '');
        }
        originalOnChange?.(event);
      },
    });
  });
};